export const signInConstant = {
    CREATE_SIGNIN_REQUEST: "CREATE_SIGNIN_REQUEST",
    CREATE_SIGNIN_SUCCESS: "CREATE_SIGNIN_SUCCESS",
    CREATE_SIGNIN_FAILURE: "CREATE_SIGNIN_FAILURE",

    // GET_SIGNIN_REQUEST: 'GET_SIGNIN_REQUEST',
    // GET_SIGNIN_SUCCESS: 'GET_SIGNIN_SUCCESS',
    // GET_SIGNIN_FAILURE: 'GET_SIGNIN_FAILURE'
}